import RenderStatsButton from './components/web/RenderStatsButton';
const renderStats = {
    key: 'render-stats',
    Content: RenderStatsButton,
    group: 5
};
/**
 * Hook returning the 描画計測 button.
 *
 * Returned unconditionally: the gate is the `toolbarButtons` allowlist in
 * config.js, which a deployment must name 'render-stats' in for the button to
 * exist at all. A second config flag would add a way to get this wrong without
 * adding a way to keep it out of production.
 *
 * @returns {Object}
 */
export function useRenderStatsButton() {
    return renderStats;
}
